import React from "react";
import { Component } from "react";
import { IDwCrossFilter, IDwFilterWarapper } from "../data/Query";
import CrossFilter from "./CrossFilter";
import '../styles/Filters.scss';
import { SocketContext } from "../context/socket";
const uuidv4 = require('uuid/v4');

interface IState {
    filters: IDwCrossFilter[];
}

class Filters extends Component<any, IState>  {
    private serverUrl = process.env.REACT_APP_CHATBOT_URL as string;
    private sessionId: string;
    private socket: SocketIOClient.Socket;

    static contextType = SocketContext;
    context!: React.ContextType<typeof SocketContext>;

    constructor(props: any) {
        super(props);

        this.state = {
            filters:[]
        };

        this.sessionId = props.sessionId as string;
        this.socket = undefined!;
    }

    componentDidMount() {
        this.socket = this.context!;

        this.socket.on('chart', (msg: any) => {
            if (msg.command === 'filterChange') {
                console.log('xx filter manager got filterChange message', msg);
                this.updateFilters(msg);
            }
        });
    }

    updateFilters(msg: any) {
        let { filters, widgetInstanceId, widgetInstanceTitle } = msg;

        let _filters = [...this.state.filters];

        // remove all the prev filters for this widget.
        //
        _filters = _filters.filter((f: IDwCrossFilter) => {
            return f.widgetInstanceId !== widgetInstanceId;
        });

        // add the new filters back into the list.
        //
        filters.forEach((f: IDwFilterWarapper) => {
            _filters.push({
                widgetInstanceId,
                widgetInstanceTitle,
                enabled: true,
                bySelection: f.bySelection,
                filter: f.filter,
                definitionId: f.definitionId,
                uuid: uuidv4()
            });
        });

        //
        this.setState({
            filters: _filters
        });

        // broadcast message the filters have been updated
        //
        this.socket.emit('chart', {
            command: 'filtersChanged',
            filters: _filters
        });
    }

    onRemoveFilter(filter: IDwCrossFilter) {
        let _filters = this.state.filters;

        const index = _filters.findIndex((f: IDwCrossFilter) => {
            return f.uuid === filter.uuid;
        });

        if(index === -1) {
            return;
        }

        _filters.splice(index, 1);

        // save state.
        //
        this.setState({
            filters: _filters
        });

        // broadcast message the filters have been updated
        //
        this.socket.emit('chart', {
            command: 'filtersChanged',
            filters: _filters
        });

        // broadcast message that user deleted filter from the filter list.
        //
        this.socket.emit('chart', {
            command: 'filterSelected',
            filter: null,
            widgetInstanceId: filter.widgetInstanceId,
            widgetInstanceTitle: filter.widgetInstanceTitle
        });
    }

    render() {
        const {filters} = this.state;

        return (
            filters.length > 0 &&
            <div className="widget">
                <div className="widgetContents">
                    <div id="filters-container">
                        <div className="filters">
                        {
                            filters && filters.sort((a, b) => a.bySelection > b.bySelection ? 1 : -1).map((filter: IDwCrossFilter, index:number) => {
                                return (<CrossFilter 
                                    key={filter.uuid} 
                                    filter={filter} 
                                    onRemoveFilter={this.onRemoveFilter.bind(this)} />);
                            })
                        }    
                        </div>
                    </div>
                </div>
            </div>                  
        );
    }
}

export default Filters;